<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 d-flex align-items-center justify-content-center">
      <b-col
        xs="12"
        sm="8"
        md="6"
        lg="4"
        class="d-flex align-items-center card p-5"
      >
        <ds-breeze-logo
          class="auth-logo"
          :height="28"
        />
        <b-col>
          <h1 class="auth-title">
            {{ $t('resetPassword.title') }}
          </h1>
          <p class="auth-description">
            {{ $t('resetPassword.description', { username }) }}
          </p>

          <ds-note
            v-if="successMessage"
            variant="success"
            live="status"
          >
            {{ successMessage }}
            <p class="auth-footer">
              <b-link :to="{ name: 'login', query: { username } }">
                {{ $t('resetPassword.backToLogin') }}
              </b-link>
            </p>
          </ds-note>

          <ds-note
            v-if="errorMessage"
            variant="danger"
            live="alert"
          >
            {{ errorMessage }}
          </ds-note>

          <validation-observer
            v-if="!successMessage"
            ref="resetPasswordValidation"
          >
            <b-form @submit.prevent="handleSubmit">
              <div class="auth-field">
                <label
                  class="auth-label"
                  for="reset-username"
                >{{ $t('resetPassword.usernameLabel') }}</label>
                <!-- type="text": this shows the account's username, which is not always an
                     email address. -->
                <ds-input
                  id="reset-username"
                  :value="username"
                  type="text"
                  autocomplete="username"
                  readonly
                />
              </div>

              <validation-provider
                #default="{ errors }"
                name="Password"
                vid="password"
                rules="required|min:8|password"
              >
                <ds-password-input
                  id="reset-password"
                  v-model="password"
                  :label="$t('resetPassword.passwordLabel')"
                  :placeholder="$t('resetPassword.passwordPlaceholder')"
                  autocomplete="new-password"
                  :show-label="$t('resetPassword.showPassword')"
                  :hide-label="$t('resetPassword.hidePassword')"
                  :error="errors[0]"
                />
              </validation-provider>

              <div class="auth-field">
                <label
                  class="auth-label"
                  for="reset-password-confirm"
                >{{ $t('resetPassword.confirmPasswordLabel') }}</label>
                <validation-provider
                  #default="{ errors }"
                  name="Confirm Password"
                  rules="required|confirmed:password"
                >
                  <ds-input
                    id="reset-password-confirm"
                    v-model="passwordConfirm"
                    type="password"
                    autocomplete="new-password"
                    :placeholder="$t('resetPassword.passwordPlaceholder')"
                    :invalid="errors.length > 0"
                    :aria-describedby="errors.length > 0 ? 'reset-password-confirm-error' : null"
                  />
                  <div
                    id="reset-password-confirm-error"
                    class="auth-error"
                    role="alert"
                  >
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <ds-button
                type="submit"
                class="auth-submit"
                :disabled="submitting"
              >
                {{ submitting ? $t('resetPassword.submitting') : $t('resetPassword.submit') }}
              </ds-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BForm, BLink,
} from 'bootstrap-vue'
import {
  DsBreezeLogo, DsButton, DsInput, DsNote, DsPasswordInput,
} from '@/design-system/components'
import {
  required, min, confirmed, password as passwordRule,
} from '@validations'
import { userService } from '@/_services/user.service'

export default {
  components: {
    DsBreezeLogo,
    DsNote,
    DsInput,
    DsPasswordInput,
    DsButton,
    BRow,
    BCol,
    BForm,
    BLink,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      password: '',
      passwordConfirm: '',
      token: '',
      username: '',
      submitting: false,
      successMessage: '',
      errorMessage: '',
      required,
      min,
      confirmed,
      passwordRule,
    }
  },
  computed: {
  },
  created() {
    this.token = this.$route.query.token || ''
    this.username = this.$route.query.username || ''

    if (!this.token) {
      this.errorMessage = this.$t('resetPassword.invalidLink')
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.resetPasswordValidation.validate().then(success => {
        if (!success) return

        this.submitting = true
        this.errorMessage = ''

        userService.resetPassword(this.token, this.password)
          .then(() => {
            this.successMessage = this.$t('resetPassword.successMessage')
            this.errorMessage = ''
          })
          .catch(() => {
            this.errorMessage = this.$t('resetPassword.errorMessage')
          })
          .finally(() => {
            this.submitting = false
          })
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>

<style lang="scss" scoped>
@import './auth-form';
</style>
